import type { CaseSectionItem } from '../types';

interface CaseSidebarItemSubtitleProps {
  item: CaseSectionItem;
  hasWarnings: boolean;
  isActive: boolean;
}

function resolveSubtitleClassName(hasWarnings: boolean, isActive: boolean): string {
  if (hasWarnings) {
    return 'text-[#BB4D00]';
  }

  if (isActive) {
    return 'text-[#008236]';
  }

  return 'text-gray-500';
}

export function CaseSidebarItemSubtitle({ item, hasWarnings, isActive }: CaseSidebarItemSubtitleProps) {
  if (!item.subTitle) {
    return null;
  }

  return (
    <div className={`mt-0.5 text-xs leading-4 ${resolveSubtitleClassName(hasWarnings, isActive)}`}>{item.subTitle}</div>
  );
}
